export default __webpack_public_path__ + "static/media/avatar2.57d0514f.jpg";